import React from 'react';
import PropTypes from 'prop-types';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';
import { useCurrentLang } from 'react-redux-app/lib/modules/i18n/hooks';

import { l } from 'react-redux-app/lib/modules/i18n/utils';
import { getBalanceSummaryUrl, getDebtUrl } from '../../utils/siteUrls';

import { getWebmasterBalanceInCredits } from '../../../webmaster/selectors';

import moneyFormatterHOC from '../../../core/money/containers/moneyFormatterHOC';

import BalancePart from './BalancePart';

import styles from './styles/index.css.json';


const propTypes = {
  formatMoney: PropTypes.func.isRequired,
};

const Balance = ({ formatMoney }) => {
  const { revenue, bonus, lossCompensationDebt } = useShortSelector(getWebmasterBalanceInCredits);
  const lang = useCurrentLang();

  const getBalancePart = (nameLangKey, value, link = null, isNegative = false) => (
    <div className={styles.balance__part}>
      <BalancePart
        name={l(nameLangKey)}
        value={formatMoney(value)}
        link={link}
        isNegative={isNegative}
      />
    </div>
  );

  return (
    <div className={styles.balance}>
      {lossCompensationDebt.amount > 0 && getBalancePart(
        'webmaster-balance.debt', lossCompensationDebt, getDebtUrl(lang), true
      )}
      {getBalancePart('webmaster-balance.revenue', revenue, getBalanceSummaryUrl(lang))}
      {bonus.amount > 0 && getBalancePart('webmaster-balance.sales-bonus', bonus)}
    </div>
  );
};

Balance.propTypes = propTypes;

export default moneyFormatterHOC(Balance);
